<!-- 大乐透中奖计算 -->
<template>
    <div class="">
      <qxcdan :fu3="ssq"></qxcdan>
      <div class="clear"></div>
    </div>
  </template>
  
  <script>
  //import '../js/mpublic.js' //js文件引入，注意路径
  import qxcdan from "@/components/jin/dan.vue";
  //import api from '@/js/method'
  export default {
    name: "",
    components: {
        qxcdan,
    },
    data() {
      // 数据源
      return {
         ssq: [{"wanfa":'qxc'}],
      };
    },
    mounted() {},
    computed: {},
    methods: {
      // 函数体部分，js的主要逻辑控制
    
    },
    props: {},
  };
  </script>
  
  
  <style scoped>
  /* @import './swiper.css'; */
  
  .clear {
    clear: both;
  }
  </style>